<template>
    <div class="orders-list">

        <div v-if="!ordersListLite" class="uk-flex k-align-items-center">
            <h1 class="uk-text-primary uk-text-bold uk-text-uppercase uk-margin-remove-bottom uk-visible@m uk-margin-medium-right">{{ resources['Orders'] }}</h1>

            <input type="text" name="q" id="searchTerm"
                   v-model="searchTerm" @keyup.enter="onFilterChanged"
                   :placeholder="resources['OrdersList_SearchByCode']"
                   class="search-orders uk-flex-1 k-alt k-border-0" />
        </div>

        <div v-if="!ordersListLite && ordersData" class="orders-counter">
            <span v-html="resources['OrdersList_Results'].format('<b>' + total + '</b>')"></span>
        </div>

        <div class="ph-item" v-if="searchIsLoading">
            <div class="ph-col-12">
                <div class="ph-picture"></div>
                <div class="ph-row">
                    <div class="ph-col-12 empty"></div>
                    <div class="ph-col-4 big"></div>
                    <div class="ph-col-2 big empty"></div>
                    <div class="ph-col-2 big"></div>
                    <div class="ph-col-2 big empty"></div>
                    <div class="ph-col-2 big"></div>
                    <div class="ph-col-12"></div>
                    <div class="ph-col-12"></div>
                    <div class="ph-col-12"></div>
                </div>
            </div>
        </div>

        <localization-provider :language="languageId + 's'">
            <intl-provider :locale="languageId + 's'">
                <grid v-if="ordersData && listColumns"
                      :columns="listColumns"
                      :data-items="ordersData"
                      :sort="sort"
                      :pageable="pageable"
                      :sortable="sortable"
                      :scrollable="none"
                      :skip="skip"
                      :take="take"
                      :total="total"
                      @pagechange="onPageChanged"
                      @sortchange="onSortChanged">
                    <template v-slot:orderCode="{ props }">
                        <td>
                            <a :href="props.dataItem.url" class="uk-text-bold blue uk-icon-link uk-link">
                                &#35 {{ props.dataItem[props.field] }}
                            </a>
                        </td>
                    </template>

                    <template v-slot:createDate="{ props }">
                        <td>
                            <span class="uk-text-center">{{ toDateString(props.dataItem[props.field]) }}</span>
                        </td>
                    </template>

                    <template v-slot:orderState="{ props }">
                        <td>
                             {{ resources['OrderState_' + props.dataItem[props.field]] }}
                        </td>
                    </template>

                    <template v-slot:paymentState="{ props }">
                        <td>
                            {{ resources['PaymentState_' + props.dataItem[props.field]] }}

                            <a v-if="props.dataItem.paymentMustBeFinalized" @click.prevent="oncompletePayment(props.dataItem.id)" href="#" class="complete-payment-btn uk-button uk-button-default white bgblue uk-text-bold uk-margin-small-top">{{ resources['CompletePayment'] }}</a>
                        </td>
                    </template>

                    <template v-slot:orderTotalAmount="{ props }">
                        <td>
                            <span class="uk-text-bold uk-text-medium">
                                {{ props.dataItem[props.field].toCurrencyString(languageId) }}
                            </span>
                            <a v-if="props.dataItem.paymentMustBeFinalized" @click.prevent="oncompletePayment(props.dataItem.id)" href="#" class="uk-hidden@m uk-button uk-button-default white bgblue uk-text-bold uk-margin-small-top">{{ resources['CompletePayment'] }}</a>
                        </td>
                    </template>
                </grid>
            </intl-provider>
        </localization-provider>
    </div>
</template>

<script lang="ts" src="./MyAccountOrders.vue.ts"></script>
